/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Box, Collapse, Grid2, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { COLORS } from '../../../utils/Application_Constants';

const useStyles = makeStyles((theme) => ({
    formHeader: {
        borderBottom: `1px solid ${COLORS.LT_MIDNIGHT25}`,
        paddingBottom: 8,
        marginBottom: 16,
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer',
    },
}));

const ImportedExpenseDetails = ({ expense }) => {
    const { importedData } = expense;
    const sortedKeys = Object.keys(importedData).sort();
    return (
        <Box mb={4}>
            <div>
                {sortedKeys.map((key) => (
                    <Typography key={key} variant="body2">
                        {key}:{' '}
                        {importedData[key].length > 1
                            ? importedData[key].join(', ')
                            : importedData[key][0]}
                    </Typography>
                ))}
            </div>
        </Box>
    );
};

const AdditionalExpenseDetails = (props) => {
    const { index, expense, isViewOnly } = props;
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <div
                className={classes.formHeader}
                onClick={() => setExpanded((prevState) => !prevState)}
            >
                <Typography variant="h5" component="h5">
                    Additional Expense Details
                </Typography>
                <ExpandMoreIcon
                    color="primary"
                    style={{
                        transition: 'transform .25s',
                        transform: `${expanded ? 'rotate(180deg)' : 'rotate(0)'}`,
                    }}
                />
            </div>
            <Collapse in={expanded}>
                <Grid2 container spacing={3}>
                    <Grid2 item size={{ xs: 12 }}>
                        {expense.importedData && <ImportedExpenseDetails expense={expense} />}
                    </Grid2>
                </Grid2>
            </Collapse>
        </>
    );
};

export default AdditionalExpenseDetails;
